import { Box, Collapse, IconButton, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';

const ReadOnlyRow = (props) => {
    const { row, setIsUpdate, setRowOriginal, setOpenNuevoProducto, setOpenDialog, setDeleteRow, selectedRow, setSelectedRow } = props;
    const [open, setOpen] = React.useState(false);

    const handleEditClick = (event, row) => {
        //console.log({ row });
        setIsUpdate(true);
        setRowOriginal(row);
        setOpenNuevoProducto(true);
    }

    const handleDeleteClick = (event, row) => {
        //console.log({ row });
        setDeleteRow(row);
        setOpenDialog(true);
    }

    const handleRowClick = (event) => {

        //console.log(row.id, event.detail);
        switch (event.detail) {
            case 1: {
                setSelectedRow(row.id);
                setRowOriginal(row);
                //console.log('single click');
                break;
            }
            case 2: {
                //console.log('double click');
                setIsUpdate(true);
                //setRowOriginal(row);
                setOpenNuevoProducto(true);
                break;
            }
            default: {
                break;
            }
        }
    }

    return (
        <Fragment>
            <TableRow onClick={handleRowClick} sx={{ '& > *': { borderBottom: 'unset' }, backgroundColor: selectedRow == row.id ? '#F7F7F7' : 'white' }}>
                <TableCell >
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row">
                    {row.id}
                </TableCell>
                <TableCell align="left">{row.product}</TableCell>
                <TableCell align="left">{row.codBar}</TableCell>
                <TableCell align="left">{row.scut}</TableCell>
                <TableCell align="left">{row.type}</TableCell>
                <TableCell align="right">{parseFloat(row.price).toFixed(2)}</TableCell>


                <TableCell key={'controles_' + row.id} align='right'>
                    <Stack direction='row' spacing={0} justifyContent={'right'}>
                        <IconButton color="primary" aria-label="edit" onClick={(event) => handleEditClick(event, row)}>
                            <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton sx={{ color: 'red' }} aria-label="edit" onClick={(event) => handleDeleteClick(event, row)}>
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    </Stack>
                </TableCell>


            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                    <Collapse in={open} timeout="auto" unmountOnExit>

                        <Box fullWidth sx={{ margin: 2, paddingBottom: 3, bgcolor: '#F7F7F7' }}>
                            <Typography variant="h6" gutterBottom component="div">
                                Precios Promocionales
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell colSpan={3} align="center">Vendaje</TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                                        <TableCell colSpan={2} align="center">Combo</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Incremento</TableCell>
                                        <TableCell>Vendaje</TableCell>
                                        <TableCell align="right">Monto Min (Bs)</TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                                        <TableCell>Incremento</TableCell>
                                        <TableCell align="right">Precio Combo (Bs)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell >{row.vStep}</TableCell>
                                        <TableCell>{row.vQty}</TableCell>
                                        <TableCell align="right">{parseFloat(row.vUmbral).toFixed(2)}</TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                                        <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                                        <TableCell>{row.cStep}</TableCell>
                                        <TableCell align="right">{parseFloat(row.cPrice).toFixed(2)}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Box>

                    </Collapse>
                </TableCell>
            </TableRow>
        </Fragment>
    );
}

export default ReadOnlyRow